"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getString = exports.set = exports.has = exports.get = exports.clear = void 0;
var stringify_1 = __importDefault(require("./stringify"));
/**
 * Cache for storing the results of the last successful compilation.
 */
var valueCache = new Map();
/**
 * Cache for storing the results of the last successful compilation as strings.
 */
var stringCache = new Map();
/**
 * Clears the cache.
 * @returns {void} Nothing.
 */
var clear = function () {
    valueCache.clear();
    stringCache.clear();
};
exports.clear = clear;
/**
 * Gets a value from the cache.
 * @param {string} key - The key to retrieve from the cache.
 * @returns {unknown} The value from the cache.
 */
var get = function (key) { return valueCache.get(key); };
exports.get = get;
/**
 * Checks if the cache has a value for the given key.
 * @param {string} key - The key to check in the cache.
 * @returns {boolean} True if the cache has a value for the key, otherwise false.
 * @example
 * cache.has(""); // false
 * cache.has("Key"); // false
 * cache.set("Key", "Value");
 * cache.has("Key"); // true
 */
var has = function (key) { return valueCache.has(key); };
exports.has = has;
/**
 * Sets a value in the cache.
 * @param {string} key - The key to store the value under.
 * @param {unknown} value - The value to store in the cache.
 * @returns {void} Nothing.
 * @example
 * cache.set("Key", "Value");
 * cache.get("Key"); // "Value"
 * cache.has("Key"); // true
 * cache.set("Key", "New Value");
 * cache.get("Key"); // "New Value"
 */
var set = function (key, value) {
    valueCache.set(key, value);
};
exports.set = set;
/**
 * Gets a string from the cache.
 * @param {string} path - The path to retrieve from the cache.
 * @param {string} tag - The tag containing the path.
 * @param {MissingPathCallback} onMissingPath - A callback function to handle missing paths.
 * @returns {string} The value from the cache as a string.
 * @example
 * getString("Key", "default value"); // "default value"
 * set("Key", "Value");
 * getString("Key", "default value"); // "Value"
 * set("Key", 42);
 * getString("Key", "default value"); // "42"
 * set("Key", undefined);
 * getString("Key", "default value"); // "default value"
 */
var getString = function (path, tag, onMissingPath) {
    if (stringCache.has(path))
        return stringCache.get(path);
    var value = valueCache.get(path);
    var text = (0, stringify_1.default)(value, path, tag, onMissingPath);
    stringCache.set(path, text);
    return text;
};
exports.getString = getString;
